type Props = {
  currentStep: number;
  totalSteps: number;
  canAdvance: boolean;
  blockerMessage: string | null;
  onBack: () => void;
  onNext: () => void;
  nextLabel?: string;
};

export function WizardNav({
  currentStep,
  totalSteps,
  canAdvance,
  blockerMessage,
  onBack,
  onNext,
  nextLabel = 'Avançar',
}: Props) {
  const showBack = currentStep > 0;

  return (
    <div className="space-y-2">
      {!canAdvance && blockerMessage && (
        <p
          role="status"
          className="rounded-xl bg-butter/60 px-3 py-2 text-xs font-medium text-plum"
        >
          {blockerMessage}
        </p>
      )}
      <div className="flex items-center gap-2">
        {showBack && (
          <button
            type="button"
            onClick={onBack}
            className="flex-1 rounded-full border-[3px] border-plum bg-white px-4 py-2.5 font-action text-sm font-bold text-plum shadow-[0_5px_0_0_#600b2e] transition-transform active:translate-y-[3px] active:shadow-[0_2px_0_0_#600b2e] sm:py-3 sm:text-base"
          >
            Voltar
          </button>
        )}
        <button
          type="button"
          onClick={onNext}
          disabled={!canAdvance}
          className={`pc-cta rounded-full border-[3px] border-plum bg-pink px-6 py-2.5 font-action text-sm font-bold text-white shadow-[0_5px_0_0_#600b2e] transition-transform active:translate-y-[3px] active:shadow-[0_2px_0_0_#600b2e] disabled:cursor-not-allowed disabled:opacity-50 disabled:active:translate-y-0 disabled:active:shadow-[0_5px_0_0_#600b2e] sm:py-3 sm:text-base ${
            showBack ? 'flex-[2]' : 'w-full'
          }`}
        >
          {nextLabel}
        </button>
      </div>
      <div className="flex justify-center gap-1.5 pt-1">
        {Array.from({ length: totalSteps }).map((_, i) => (
          <span
            key={i}
            aria-hidden="true"
            className={`h-1.5 rounded-full transition-all ${
              i === currentStep
                ? 'w-6 bg-plum'
                : i < currentStep
                  ? 'w-1.5 bg-plum/60'
                  : 'w-1.5 bg-plum/15'
            }`}
          />
        ))}
        <span className="sr-only">
          Etapa {currentStep + 1} de {totalSteps}
        </span>
      </div>
    </div>
  );
}
